import React, { useEffect } from 'react';
import { Route, useLocation, useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import {
  getDefaultRoute,
  buildRedirectParamsFromUserInfo,
} from 'utils/getDefaultRoute';

const PublicRoutes = (props) => {
  const {
    layout: Layout,
    component: Component,
    current,
    noFooter,
    noTopbar,
    leftSidebar,
    competeSidebar,
    ...rest
  } = props;
  const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);
  const location = useLocation();
  const history = useHistory();

  useEffect(() => {
    if (location.pathname === '/' && isLoggedIn) {
      const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
      const defaultRoute = getDefaultRoute(
        buildRedirectParamsFromUserInfo(userInfo),
      );
      history.push(defaultRoute);
    }
  }, [isLoggedIn]);

  return (
    <Route
      {...rest}
      render={(matchProps) => (
        <Layout
          current={current}
          noTopbar={noTopbar}
          noFooter={noFooter}
          leftSidebar={leftSidebar}
          competeSidebar={competeSidebar}
        >
          <Component {...matchProps} />
        </Layout>
      )}
    />
  );
};

PublicRoutes.propTypes = {
  component: PropTypes.any.isRequired,
  layout: PropTypes.any.isRequired,
  current: PropTypes.string,
  noFooter: PropTypes.bool,
  noTopbar: PropTypes.bool,
  path: PropTypes.string,
  leftSidebar: PropTypes.bool,
  competeSidebar: PropTypes.bool,
};

export default PublicRoutes;
